// All properties sorted alphabetically.
export enum LoggingEventCategory {
  ai = 'AI',
  error = 'error',
  sw = 'SW',
}

// All properties sorted alphabetically.
export enum LoggingEvent {
  BackButtonClick = 'back-button-click',
  BackFromCategory = 'back-from-category',
  BackFromHighlights = 'back-from-highlights',
  BackFromOffer = 'back-from-offer',
  BackFromRegion = 'back-from-region',
  BackFromSearch = 'back-from-search',
  BackFromSubCategory = 'back-from-sub-category',
  BreadcrumbCategory = 'breadcrumb-category',
  BreadcrumbSubCategory = 'breadcrumb-sub-category',
  CategoryClick = 'category-click',
  error = 'error',
  exception = 'exception',
  ExternalLinkClick = 'external-link',
  FooterContactClick = 'footer-contact-click',
  FooterTelegramClick = 'footer-telegram-click',
  FooterWhatsAppClick = 'footer-whatsapp-click',
  MainScreenClick = 'main-screen-button-click',
  NotFoundCategory = 'not-found-category',
  NotFoundOffer = 'not-found-offer',
  NotFoundParentQuestion = 'not-found-parent-question',
  NotFoundParentQuestionIsSelf = 'not-found-parent-question-is-self',
  NotFoundSheetRows = 'not-found-sheet-rows',
  NotFoundSubCategory = 'not-found-sub-category',
  OfferClick = 'offer-click',
  OfferDetailClick = 'offer-detail-click',
  Print = 'print',
  QuestionClose = 'question-close',
  QuestionOpen = 'question-open',
  SubCategoryClick = 'sub-category-click',
  SwUpdateActivated = 'sw-update-activated',
  SwUpdateAvailable = 'sw-update-available',
  SwUpdateNotActivated = 'sw-update-not-activated',
  SwUpdateNotAvailable = 'sw-update-not-available',
}
